import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { FaUser, FaProjectDiagram, FaTools, FaEnvelopeOpenText, FaBriefcase } from 'react-icons/fa';
import Loading from './components/Loading';
import { ThemeProvider } from './contexts/ThemeContext';

const savedTheme = localStorage.getItem('theme') || 'light';
document.documentElement.setAttribute('data-theme', savedTheme);
document.body.classList.add(savedTheme === 'dark' ? 'dark-mode' : 'light-mode');

// Lazy load components
const About = lazy(() => import('./components/About'));
const Projects = lazy(() => import('./components/Projects'));
const Skills = lazy(() => import('./components/Skills'));
const Contact = lazy(() => import('./components/Contact'));
const Experience = lazy(() => import('./components/Experience'));
const root = ReactDOM.createRoot(document.getElementById('root'));
const components = [
  { 
    name: 'About', path: '/about', icon: <FaUser />, component: () => (<Suspense fallback={<Loading />}><About /></Suspense>)},
  { name: 'Experience', path: '/experience', icon: <FaBriefcase />, component: Experience },
  { name: 'Research', path: '/projects', icon: <FaProjectDiagram></FaProjectDiagram>, component: Projects }, 
  { name: 'Skills', path: '/skills', icon: <FaTools></FaTools>, component: Skills },
  { name: 'Contact', path: '/contact', icon: <FaEnvelopeOpenText></FaEnvelopeOpenText>, component: Contact }
];
root.render(
  <Router>
    <ThemeProvider>
      <App components={components}/>
    </ThemeProvider>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
